<template>
  <div class="content-wrapper">
    <section class="content-header">
      <div class="row">
        <div class="col-xs-12">
          <h1 class="pull-left">PIN reports</h1>
          <div class="pull-right">
            <a
              href="#"
              @click="downloadNow"
              class="btn"
              style="background-color: #526883; color: white"
              ><i class="fa fa-download"></i> Download Filtered</a
            >
            &nbsp;
            <a
              href="#"
              class="btn"
              style="background-color: #526883; color: white; display: none"
              ><i class="fa fa-cloud-download" style="font-size: 16px"></i>
              Download All</a
            >
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <form v-on:submit.prevent="searchReportData">
        <div class="row">
          <div class="col-xs-6 col-sm-2">
            <div class="form-group">
              <filterDropdownOptions />
            </div>
          </div>
          <div class="col-xs-6 col-sm-2 form-group">
            <input
              placeholder="From"
              type="text"
              value=""
              name="starttime"
              id="starttime"
              v-model="starttime"
              autocomplete="off"
              class="form-control input-sm datePicker"
            />
          </div>
          <div class="col-xs-6 col-sm-2 form-group">
            <input
              placeholder="To"
              type="text"
              value=""
              name="stoptime"
              id="stoptime"
              v-model="stoptime"
              class="form-control input-sm datePicker"
              autocomplete="off"
            />
          </div>
          <div class="col-xs-6 col-sm-2 form-group" v-if="showDropdown">
            <select
              title=""
              name="is_online"
              id="is_online"
              v-model="is_online"
              v-select="is_online"
              class="form-control input-sm select2"
              @change="searchReportData"
            >
              <option value="" selected="">All (Offline + Online)</option>
              <option value="2">Offline</option>
              <option value="1">Online</option>
            </select>
          </div>
          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="type"
              id="type"
              v-model="type"
              v-select="type"
              class="form-control input-sm select2"
              @change="searchReportData"
            >
              <option value="">Select Type</option>
              <option value="1">Sell</option>
              <option value="2">Return</option>
            </select>
          </div>
          <div class="col-xs-6 col-sm-2 form-group">
            <select
              title=""
              name="id_reseller"
              id="id_reseller"
              v-model="id_reseller"
              v-select="id_reseller"
              class="form-control input-sm select2"
              @change="searchReportData"
            >
              <option value="">All Reseller</option>
              <option
                v-for="(data, index) in reseller_list"
                :key="index"
                :value="index"
              >
                {{ data }}
              </option>
            </select>
          </div>

          <div class="col-xs-6 col-sm-2 form-group">
            <input
              placeholder="Search By PIN"
              type="text"
              name="login"
              id="login"
              v-model="login"
              class="form-control input-sm"
              value=""
            />
          </div>

          <div
            id="btnSearch"
            class="col-xs-6 col-sm-2 pull-right form-group btnLeft"
            style="margin-bottom: 5px"
          >
            <button type="submit" class="btn btn-sm btn-submit pull-right">
              <i class="fa fa-search"></i> Search
            </button>
          </div>
        </div>
      </form>
      <div class="row">
        <div class="col-md-12">
          <div class="box" id="pagination">
            <div class="box-header">
              <h3 class="box-title">Total {{ listArr.length }} Row Found</h3>
            </div>
            <div class="box-body">
              <div class="table-responsive">
                <table class="table table-0024 table-bordered table-striped">
                  <thead>
                    <tr>
                      <th class="tdCenter tdSN">SN</th>
                      <th class="tdCenter">PIN</th>
                      <th class="tdCenter">Login/Return Date</th>
                      <th class="tdCenter">Expiry Date</th>
                      <th class="tdCenter">Plan</th>
                      <th class="tdCenter">NOD</th>
                      <th class="tdCenter">Parent Of PIN</th>
                      <th class="tdCenter">Type</th>
                      <th class="tdCenter">Billing Price</th>
                      <th class="tdCenter">Selling Price</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(data, index) in listArr" :key="data.id">
                      <td class="tdCenter tdSN">
                        {{ parseInt(++index) }}
                      </td>
                      <td
                        :class="
                          data.type == 2
                            ? ' tdCenter danger'
                            : 'tdCenter success'
                        "
                      >
                        {{
                          com_removeHostedPinPrefix(
                            data.username,
                            userData.reseller4.hosted_pin_prefix,
                            userData.reseller4.reseller_panel_type
                          )
                        }}
                      </td>
                      <td class="tdCenter">
                        {{ data.creationdate }}
                      </td>
                      <td
                        :class="
                          data.type == 2 ? 'tdCenter text-red' : 'tdCenter'
                        "
                      >
                        {{ data.expire_date }}
                      </td>
                      <td
                        :class="
                          data.type == 2 ? 'tdCenter text-red' : 'tdCenter'
                        "
                      >
                        {{ data.description }}
                      </td>
                      <td
                        :class="
                          data.type == 2 ? 'tdCenter text-red' : 'tdCenter'
                        "
                      >
                        {{ data.no_of_days }}
                      </td>
                      <td
                        :class="
                          data.type == 2 ? 'tdCenter text-red' : 'tdCenter'
                        "
                      >
                        {{ data.parent_label }}
                      </td>
                      <td class="tdCenter">
                        <span class="label label-success" v-if="data.type == 1">
                          Sale
                        </span>
                        <span class="label label-danger" v-if="data.type == 2">
                          Return
                        </span>
                      </td>
                      <td
                        :class="
                          data.type == 2
                            ? 'tdRight info text-red'
                            : 'tdRight info'
                        "
                      >
                        <span v-if="data.type == 2">-</span>
                        <span v-if="data.is_online == 2">{{
                          data.billing_price
                        }}</span>
                        <span v-else>
                          <span v-if="showOnlineBillingPrice">{{
                            data.billing_price
                          }}</span>
                          <span v-else="showOnlineBillingPrice">0.00</span>
                        </span>
                      </td>
                      <td
                        :class="
                          data.type == 2
                            ? 'tdRight info text-red'
                            : 'tdRight info'
                        "
                      >
                        <span v-if="data.type == 2">-</span>
                        <span>{{ data.reseller_price }}</span>
                      </td>
                    </tr>
                    <tr v-if="listArr.length == 0">
                      <td colspan="10" class="tdCenter" style="padding: 30px 0">
                        <b>No Records Found</b>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div class="table-responsive">
              <table class="table table-middle-small table-bordered">
                <thead>
                  <tr>
                    <th class="tdCenter">Total Records</th>
                    <th class="tdCenter">Returned Record</th>
                    <th class="tdCenter">Total Billing</th>
                    <th class="tdCenter">Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td class="success">{{ listArr.length }}</td>
                    <td class="warning">{{ return_count }}</td>
                    <td class="danger">{{ total_billing_amount }}</td>
                    <td class="info">
                      {{ total_last_retail_payment }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import filterDropdownOptions from "@/components/common/filterDropdownOptions.vue";
import axios from "axios";
export default {
  name: "PinSubscriptionReport",
  components: {
    filterDropdownOptions,
  },
  data() {
    return {
      listArr: [],
      userData: {},
      reseller_list: {},
      lineTotalAmount: 0,
      type: "",
      id_reseller: "",
      starttime: "",
      stoptime: "",
      is_online: "",
      login: "",
      userlevel: "",
      total_last_retail_payment: 0,
      total_billing_amount: 0,
      return_count: 0,
      showDropdown: false,
      showOnlineBillingPrice: false,
    };
  },
  created() {
    this.com_user_type_access([0,1,5,6,7,7], true, [1,2, 3, 4]);
    //Get User Level from user store
    var encryptedData = this.$store.getters.getUser;
    var decodedString = this.com_DecryptString(encryptedData);
    var userData = JSON.parse(decodedString);
    this.userData = userData;
    this.userlevel = userData.user_level;
    console.log(JSON.parse(JSON.stringify(userData)));
    let hasInapp = (userData?.reseller4?.has_inapp_purchase == 1 && userData?.reseller4?.billing_for_renewal == 1 ) ? true : false;
    //Octovault = 411
    if ((userData.id_reseller == 411 && userData.user_level == 4) || (userData.reseller4.affiliate_type == 5 || userData.reseller4.affiliate_type == 6 || userData.reseller4.affiliate_type == 7 || userData.reseller4.affiliate_type == 7) || hasInapp) {
      this.showOnlineBillingPrice = true;
    }
    // End

    this.showDropdown = this.com_onlineReportAccess();

    var rootObject = this;
    loader.show();
    axios
      .get("get-reseller-dropdown-data")
      .then(function (response) {
        rootObject.reseller_list = response.data.data;
      })
      .catch(function (error) {
        let alertmessage = "";
        for (var prop in error.response.data) {
          alertmessage += " " + error.response.data[prop];
        }
        console.log(alertmessage);
        rootObject.com_errorHandel(error);
      });

    this.filterWiseDateRangeSet();
    this.searchReportData();
  },
  methods: {
    downloadNow() {
      loader.show();
      var rootObject = this;

      const form = new FormData();
      form.append("type", this.type);
      form.append("fromDate", this.starttime);
      form.append("toDate", this.stoptime);
      form.append("id_reseller", this.id_reseller);
      form.append("login", this.login);
      form.append("is_online", this.is_online);
      form.append("allow_child", 1);
      form.append("download", 1);
      form.append("short_filter", $("#short_filter").val());

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
        responseType: "blob",
      };

      axios
        .post("reports/pin-subscription", form, config)
        .then(function (response) {
          //console.log(response);
          const blob = new Blob([response.data], { type: "application/csv" });
          var a = document.createElement("a");
          var url = window.URL.createObjectURL(blob);
          a.href = url;
          var prefix = "subscription_report_";
          var file_name = prefix.concat(rootObject.getFormattedTime());
          var ext = ".csv";
          a.download = file_name.concat(ext);
          document.body.append(a);
          a.click();
          a.remove();
          window.URL.revokeObjectURL(url);
          loader.hide();
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    searchReportData() {
      loader.show();
      var rootObject = this;

      const form = new FormData();
      form.append("type", this.type);
      form.append("fromDate", this.starttime);
      form.append("toDate", this.stoptime);
      form.append("id_reseller", this.id_reseller);
      form.append("login", this.login);
      form.append("is_online", this.is_online);
      form.append("allow_child", 1);
      form.append("short_filter", $("#short_filter").val());

      var config = {
        headers: { "Content-Type": "multipart/form-data" },
      };

      axios
        .post("reports/pin-subscription", form, config)
        .then(function (response) {
          //console.log(response);
          rootObject.populateReportData(response);
        })
        .catch(function (error) {
          let alertmessage = "";
          for (var prop in error.response.data) {
            alertmessage += " " + error.response.data[prop];
          }
          console.log(alertmessage);
          loader.hide();
          rootObject.com_errorHandel(error);
        });
    },

    populateReportData(response) {
      var rootObject = this;
      var creationdate = "";
      var no_of_days = 0;
      var total_last_retail_payment = 0;
      var total_billing_amount = 0;
      var return_count = 0;
      this.listArr = [];
      this.total_last_retail_payment = 0;
      this.total_billing_amount = 0;
      this.return_count = 0;

      var childArr = response.data.data.childArr;
      for (var prop in response.data.data.pinData) {
        var parent_label = "";
        var childResArr = [];
        if (this.userlevel == 4) {
          childResArr = [3, 2, 1];
        }
        if (this.userlevel == 3) {
          childResArr = [2, 1];
        }
        if (this.userlevel == 2) {
          childResArr = [1];
        }

        if (childResArr.includes(1)) {
          if (response.data.data.pinData[prop]["reseller_level_1_id"] > 0) {
            var rId = response.data.data.pinData[prop]["reseller_level_1_id"];
            parent_label += childArr[1][rId]["login"] + " -> ";
          }
        }

        if (childResArr.includes(2)) {
          if (response.data.data.pinData[prop]["reseller_level_2_id"] > 0) {
            var rId = response.data.data.pinData[prop]["reseller_level_2_id"];
            parent_label += childArr[2][rId]["login"] + " -> ";
          }
        }

        if (childResArr.includes(3)) {
          if (response.data.data.pinData[prop]["reseller_level_3_id"] > 0) {
            var rId = response.data.data.pinData[prop]["reseller_level_3_id"];
            parent_label += childArr[3][rId]["login"] + " -> ";
          }
        }
        parent_label += "Self";

        response.data.data.pinData[prop]["parent_label"] = parent_label;

        if (this.userlevel == response.data.data.pinData[prop]["level"]) {
          response.data.data.pinData[prop]["reseller_price"] =
            response.data.data.pinData[prop]["selling_price"];
        } else {
          response.data.data.pinData[prop]["reseller_price"] =
            response.data.data.pinData[prop][
              "reseller_level_" + (this.userlevel - 1) + "_price"
            ];
        }

        var billing_price =
          response.data.data.pinData[prop][
            "reseller_level_" + this.userlevel + "_price"
          ];
        console.log('billing_price);', billing_price);
        response.data.data.pinData[prop]["billing_price"] = billing_price;

        if (response.data.data.pinData[prop]["type"] == 2) {
          return_count++;
          response.data.data.pinData[prop]["expire_date"] = "00-00-00 00:00:00";
          total_last_retail_payment =
            parseFloat(total_last_retail_payment) -
            parseFloat(response.data.data.pinData[prop]["reseller_price"]);

          if (
            response.data.data.pinData[prop]["is_online"] == 2 ||
            this.showOnlineBillingPrice == true
          ) {
            total_billing_amount =
              parseFloat(total_billing_amount) - parseFloat(billing_price);
          }
        } else {
          total_last_retail_payment =
            parseFloat(total_last_retail_payment) +
            parseFloat(response.data.data.pinData[prop]["reseller_price"]);
          no_of_days = response.data.data.pinData[prop]["no_of_days"];
          creationdate = response.data.data.pinData[prop]["creationdate"];
          if (no_of_days > 0) {
            response.data.data.pinData[prop][
              "expire_date"
            ] = this.com_modifyDateTime(no_of_days, creationdate);
          } else {
            response.data.data.pinData[prop]["expire_date"] = "";
          }

          if (
            response.data.data.pinData[prop]["is_online"] == 2 ||
            this.showOnlineBillingPrice == true
          ) {
            total_billing_amount =
              parseFloat(total_billing_amount) + parseFloat(billing_price);
          }
        }
        this.listArr.push(response.data.data.pinData[prop]);
      }

      this.return_count = return_count;
      this.total_last_retail_payment = total_last_retail_payment.toFixed(2);
      this.total_billing_amount = total_billing_amount.toFixed(2);
      loader.hide();
    },

    filterWiseDateRangeSet() {
      $(".datePicker").removeAttr("readonly", "readonly");
      if ($("#short_filter").val()) {
        this.starttime = "";
        this.stoptime = "";
        $(".datePicker").attr("readonly", "readonly");
      } else {
        var dateRangeArr = this.com_currentDateRange();
        this.starttime = dateRangeArr.startDate;
        this.stoptime = dateRangeArr.endDate;
      }
    },

    getFormattedTime() {
      var today = new Date();
      var y = today.getFullYear();
      var m = today.getMonth() + 1;
      var d = today.getDate();
      return y + "-" + m + "-" + d;
    },
  },
  mounted: function () {
    var rootObject = this;
    $("#starttime")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
      })
      .on("change", function (e) {
        rootObject.starttime = $(this).val();
      });

    $("#stoptime")
      .datetimepicker({
        timepicker: false,
        format: "Y-m-d",
      })
      .on("change", function (e) {
        rootObject.stoptime = $(this).val();
      });

    $("#short_filter").on("change", function () {
      rootObject.filterWiseDateRangeSet();
      rootObject.searchReportData();
    });

    $(".select2").select2();
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
